export const defaultValues = {
  title: '',
  loopAudio: false,
  soundInfo: {},
  backgroundAttachment: null,
  mobileBackgroundAttachment: null,
  fadeIn: 0.5,
  fadeOut: 0.5,
};
